module.exports = __webpack_public_path__ + "img/tuite.496297b.png";